import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ClearSessionWrapper = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    console.log("running", location.pathname);
    if (location.pathname === '/Familydetails') {
        console.log("running inside", location.pathname);
    //   sessionStorage.removeItem("FlatnTower");
    }else if(location.pathname === '/Management'){
        console.log("running inside", location.pathname);
    }else{
        console.log("running Clear", location.pathname);
        sessionStorage.removeItem("FlatnTower");
    }

    if (location.pathname === '/ComplaintDashboard') {
      console.log("running inside", location.pathname);
      localStorage.removeItem("UrgentStats");
        localStorage.removeItem("StatusHelp")
        localStorage.removeItem("TodayStartDate")
        localStorage.removeItem("TodayEndDate")
        localStorage.removeItem("SocietyLevel")
    //   sessionStorage.removeItem("FlatnTower");
    }else if(location.pathname === '/Management'){
        console.log("running inside", location.pathname);
    }else{
        console.log("running Clear", location.pathname);
        // sessionStorage.removeItem("FlatnTower");
        localStorage.removeItem("UrgentStats");
        localStorage.removeItem("StatusHelp")
        localStorage.removeItem("TodayStartDate")
        localStorage.removeItem("TodayEndDate")
        localStorage.removeItem("SocietyLevel")
    }
  }, [location]);

  return <>{children}</>;
};

export default ClearSessionWrapper;

